import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import API from "api.js";
import "swiper/swiper-bundle.css";
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css';
import { Navigation, Pagination } from "swiper/modules";
import Introduction from "components/StgyVideos/Introduction";
import Category from "components/StgyVideos/Category";
import { store } from "store/index";
import { setAlert } from "action";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import SpeakingZone from "assets/images/images_new/microphone-icon.svg";
import WritingZone from "assets/images/images_new/writing-icon.svg";
import ReadingZone from "assets/images/images_new/reading-icon.svg";
import ListeningZone from "assets/images/images_new/listening-icon.svg";
import TipIcon from "assets/images/images_new/tip-icon.png";
// import StrategyVideoTour from "components/WebsiteTour/StrategyVideoTour";
import FinalTips from "components/StgyVideos/FinalTips";
import Spinner from "components/Loader/Spinner";
import EmptyData from "components/EmptyData/EmptyData";

// import { Row, Col } from "reactstrap";
// import SidebarClose from "components/Sidebar/SidebarClose";
// import SwiperCore, { Pagination, Navigation } from "swiper";
// import VideoIcon from "assets/images/images_new/video-icon.svg";

const classes = [
  "",
  "speakingVideos",
  "writingVideos",
  "readingVideos",
  "listeningVideos",
];

const Video = (props) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [videoPlan, setVideoPlan] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState([]);
  const [showTour, setShowTour] = useState(false);

  useEffect(() => {
    API({
      method: "GET",
      url: "user-data-get/active_subscription",
    }).then((data) => {
      let active_subscription = data.data.user.active_subscription;
      setActiveSubscription(active_subscription);
      if (
        active_subscription.length > 0 &&
        active_subscription[0].package_id === 9
      ) {
        setModal1(true);
      }
    }).catch(() => { });

    loadVideo();
  }, []);

  const loadVideo = () => {
    setIsLoading(true)
    API({
      method: "GET",
      url: "get-stgy-videos",
    }).then((data) => {
      if (data.status === 200 || data.status === 207) {
        setData(data.data.video);
        setIsLoading(false)
        setShowTour(true);
        return;
      }
      store.dispatch(
        setAlert({ flag: true, type: 2, message: "Something went wrong." })
      );
    }).catch(() => {
      setIsLoading(false)
    });
  };

  const closeModal = () => {
    setModal1(false);
  };

  /*
  * 2. Speaking Zone
  * 3. Writing Zone  
  * 4. Reading Zone  
  * 5. Listening Zone  
  */
  const categoryIcon = (category) => {
    let icon = "";
    switch (category) {
      case 2:
        icon = SpeakingZone;
        break;
      case 3:
        icon = WritingZone;
        break;
      case 4:
        icon = ReadingZone;
        break;
      case 5:
        icon = ListeningZone;
        break;
      case 6:
        icon = TipIcon;
        break;
      default:
        break;
    }
    return icon;
  };

  const sectionIds = [
    "SecretStrategyVideo",
    "speakingvideos",
    "writingvideos",
    "readingvideos",
    "listeningvideos",
  ];

  return (
    <div className="content p-0 w-100">
      <DashboardHeader title="Secret Strategy video" />
      <div className="outer-wrapper" id="secret-strategy-page">
        {isLoading ? <Spinner /> :
          data?.length === 0 ? (
            <EmptyData />
          ) : (
            data
              .filter((category) => category.id !== 6)
              .map((category, index) => {
                const sectionId = sectionIds[index] || "";
                return category.id === 1 ? (
                  <Introduction
                    id={sectionId}
                    key={category.id}
                    title={category.title}
                    video={category.stgy_vid}
                  />
                ) : (
                  <Category
                    key={category.id}
                    id={sectionId}
                    containerClass={classes[index] ? classes[index] : "speakingVideos"}
                  >
                    <Category.Title>
                      <img src={categoryIcon(category.id)} alt="LA" /> {category.title}
                    </Category.Title>
                    
                    <Swiper
                      modules={[Navigation, Pagination]}
                      navigation={{
                        nextEl: `.right-btn-${category.id}`,
                        prevEl: `.left-btn-${category.id}`,
                      }}
                      watchOverflow={true}
                      spaceBetween={20}
                      keyboard={true}
                      slidesPerView={1}
                      slidesPerGroup={1}
                      pagination={{
                        clickable: true,
                        el: `.swiper-custom-pagination-${category.id}`,
                      }}
                      breakpoints={{
                        300: { slidesPerView: 1, spaceBetween: 20 },
                        500: { slidesPerView: 2, spaceBetween: 20 },
                        760: { slidesPerView: 3, spaceBetween: 20 },
                        820: { slidesPerView: 3, spaceBetween: 20 },
                        1024: { slidesPerView: 3, spaceBetween: 30 },
                        1280: { slidesPerView: 4, spaceBetween: 30 },
                        1440: { slidesPerView: 5, spaceBetween: 30 },
                        1850: { slidesPerView: 6, spaceBetween: 30 },
                        2200: { slidesPerView: 7, spaceBetween: 30 },
                      }}
                      className="w-100"
                      style={{ minHeight: '220px' }}
                    >
                      {category.stgy_vid.map((video) => (
                        <SwiperSlide key={video.id}>
                          <Category.List>
                            <Category.Item
                              title={video.title}
                              description={video.description}
                              thumbnail={video.thumbnail}
                              vidLink={video.link}
                              id={video.id}
                            />
                          </Category.List>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                    <div className="swiper-nav-row">
                      <button className={`custom-nav-btn left-btn left-btn-${category.id}`}>
                        <svg width="14" height="14" viewBox="0 0 24 24">
                          <path d="M15 18l-6-6 6-6" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                      <div className={`swiper-pagination swiper-custom-pagination-${category.id}`}></div>
                      <button className={`custom-nav-btn right-btn right-btn-${category.id}`}>
                        <svg width="14" height="14" viewBox="0 0 24 24">
                          <path d="M9 6l6 6-6 6" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                    </div>
                  </Category>
                );
              })
          )}
        {/* <div className="final-tips-wrapper">
          <div className="final-tips-title">Final Tips</div>
          <p className="final-tips-description">More than 107 students got their desired score with LA in the last month. This Final Tips could help you</p>
          <button className="final-tips-btn"><img src={VideoIcon} alt="LA" /> Final Tips for Exam</button>
        </div> */}
        {data
          .filter((category) => category.id === 6)
          .map((finalCategory) =>
            finalCategory.stgy_vid.map((video) => (
              <FinalTips video={video} />
            ))
          )}
        {/* {showTour && <StrategyVideoTour autoStart={true} onComplete={() => setShowTour(false)} /> } */}
      </div>
    </div>
  );
};

export default Video;